module.exports = __webpack_public_path__ + "static/media/sent.bb025af6.svg";